export const GET_SPECIALTIES_SUCCESS = 'GET_SPECIALTIES_SUCCESS';
export const GET_SPECIALTIES_FAILURE = 'GET_SPECIALTIES_FAILURE';

export const GET_SPECIALTIES_BY_INDUSTRIES_SUCCESS = 'GET_SPECIALTIES_BY_INDUSTRIES_SUCCESS';
export const GET_SPECIALTIES_INDUSTRIES_FAILURE = 'GET_SPECIALTIES_INDUSTRIES_FAILURE';
export const CLEAR_INDUSTRIES_SPECIALTIES_SUCCESS = 'CLEAR_INDUSTRIES_SPECIALTIES_SUCCESS';
